  <div id="tempprofile"
    class="bg-white px-3 mb-3 position-relative d-flex border-card">
    <div [class]=" this.mls.featureOnOffList.featureList.connectionCountOnGrProfile.value || !mls.userLoginFlow ? 'user-profile-box mb-1 d-flex min-height-154 pt-3' : 'user-profile-box mb-1 d-flex py-3'"  id="profile_show_hide">
      <div class="user-profile-pic cursor-pointer mx-auto flex-shrink-0 box-size-50">
        <app-user-pofile-pic
          [profile_pic_image]="profile_left_pic_image">
        </app-user-pofile-pic>
      </div>

    <div *ngIf="profileInfo!=null"
      class="user-detail cursor-pointer"
      (click)="navifateToProfile()"
      [eventTracker]='{"category":"explore panel","action":ems.ProfileLeftComponent.user_profile}' ><p class="paragraph-bold ellipsis width-160 ml-2 "><span class="color-deep-green">
      {{dss.user_profile_data?.profile?.first_name+' '+dss.user_profile_data?.profile?.middle_name+' '+dss.user_profile_data?.profile?.last_name}}</span></p>
      <p (click)="navifateToProfile()"
        *ngIf="primary_speciality!=''"
        class="secondary-paragraph pl-2"><span class="color-grey-500">{{primary_speciality }}</span>
      </p>
    </div>

    <div *ngIf="(this.mls.featureOnOffList.featureList.connectionCountOnGrProfile.value || !mls.userLoginFlow)" class="separator-line bg-deep-green-100 bottom-0 left-0 position-absolute connection-container">
      <div (click)="funCollectionService.navigateToProfileConnection(dss.user_profile_data.profile.custom_id)"
        class="px-3 text-center cursor-pointer secondary-paragraph d-flex justify-content-between w-100"
        [eventTracker]='{"category":mls.googleEventText.grandround_left_section.category,"action":dss.user_profile_data?.user_connection?.total_connections_text,"product_type":"", "product_id":""}'>
        <span>
          <span class="color-grey-700 mr-1">{{dss.user_profile_data?.user_connection?.total_connections}}</span>
          <span class="color-grey-700">{{dss.user_profile_data?.user_connection?.total_connections_text}}</span>
        </span>
        <span>
          <img height="12" src="assets/themes/icons/right-arrow-head.svg" alt="navigate to connection icon" />
        </span>
      </div>
    </div>
    <!-- end connection counting -->
    </div>
	</div>

  <!-- feed -->
      <div class="bg-white border-card left-navigation-container">
        <div  class="secondary-paragraph-bold pb-2 mt-1">
          <ul>
            <li>
              <div class="px-3 menu-item" [ngClass]="{'active-menu': selectedMenuItem ===''}">
                <span class="color-black mr-2">
                  <img width="24px" src="assets/themes/images/clinincal experience.svg" alt="home feed" />
                </span>{{mls?.languageText?.grandround_left_section?.key1}}<span *ngIf="mls?.is_lskey_display==1">(grandround_left_section.key1)</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="separator-line"></div>
      <!-- end feed  -->
      <!-- explore -->
      <div class="ps position-relative" style="max-height: 52vh;" [perfectScrollbar]="config">
      <div >
        <div class="mb-2" *ngFor="let exp of masterService.explore_array">
          <p class="secondary-paragraph-bold my-2 px-3"><span class="color-grey-400">{{exp.group_name}}</span></p>
            <ul class="clearfix">
              <ng-container *ngFor="let expProd of exp.products" >
                <li *ngIf="expProd.value!=='mydownload' && expProd.value!=='contributor' && expProd.value!=='rewards' && expProd.value!=='chats'">
                    <!-- dss.isChatShow=='1' -->
                    <div class="px-3 menu-item" [ngClass]="{'active-menu': selectedMenuItem === expProd.value}">
                      <a [dataTestId]="expProd?.id" [dataTestIdName]="dataTestId.EXPLORE_SECTION_HAMBURGER_MENU + '-' + expProd?.value" class="cursor-pointer d-block secondary-paragraph-bold"  (click)="navigateFromExplore(expProd)"  *ngIf="expProd.value!=='mydownload' && expProd.value!=='contributor' && expProd.value!=='rewards' && expProd.value!=='chats'">
                          <!-- <span class="mr-2"><img width="15px" src="{{expProd.icon_url}}"></span>  -->
                        <span class="mr-3">
                          <img *ngIf="expProd.value==exploreSection.PHARMA" class="explore-menu-icon"  src={{expProd.icon_url}}   onerror="this.src='assets/themes/icons/gr/channels.svg'">
                          <img *ngIf="expProd.value===exploreSection.CHANNEL" class="explore-menu-icon"  src={{expProd.icon_url}}   onerror="this.src='assets/themes/icons/gr/channels.svg'">
                          <img *ngIf="expProd.value===exploreSection.CME" class="explore-menu-icon"   src={{expProd.icon_url}}  onerror="this.src='assets/themes/icons/gr/cme.svg'">
                          <img *ngIf="expProd.value===exploreSection.DOCTALK" class="explore-menu-icon"  src={{expProd.icon_url}}   onerror="this.src='assets/themes/icons/gr/doctalks.svg'">
                          <img *ngIf="expProd.value===exploreSection.WEBINAR" class="explore-menu-icon"  src={{expProd.icon_url}}   onerror="this.src='assets/themes/icons/gr/webinar.svg'">
                          <img *ngIf="expProd.value===exploreSection.SURVEY" class="explore-menu-icon"  src={{expProd.icon_url}}   onerror="this.src='assets/themes/icons/gr/surveys.svg'">
                          <img *ngIf="expProd.value===exploreSection.JOURNAL" class="explore-menu-icon" src={{expProd.icon_url}}   onerror="this.src='assets/themes/icons/gr/reference.svg'">
                          <img *ngIf="expProd.value===exploreSection.EVENT" class="explore-menu-icon" src={{expProd.icon_url}}   onerror="this.src='assets/themes/icons/gr/offline-event.svg'">
                          <img *ngIf="expProd.value===exploreSection.CLINICAL_CASES" class="explore-menu-icon" src={{expProd.icon_url}}   onerror="this.src='assets/themes/icons/gr/clinical-case.svg'">
                          <!-- <img *ngIf="expProd.value=='rewards'" width="15px" style="margin-top: -3px;" src="assets/images/profile-explore/rewards.svg">
                            -->
                          <img *ngIf="expProd.value===exploreSection.POLL" class="explore-menu-icon" src={{expProd.icon_url}}   onerror="this.src='assets/themes/icons/gr/poll.svg'">
                          <img *ngIf="expProd.value===exploreSection.DRUG_SAMPLE" class="explore-menu-icon" src={{expProd.icon_url}}   onerror="this.src='assets/images/profile-explore/drugs_sample.svg'">
                          <img *ngIf="expProd.value===exploreSection.MY_BOOKMARKS" class="explore-menu-icon" src={{expProd.icon_url}}   onerror="this.src='assets/images/profile-explore/mybookmarks.svg'">
                          <!-- expProd.icon_url -->
                          <img *ngIf="expProd.value===exploreSection.CONNECTION" class="explore-menu-icon" src={{expProd.icon_url}}  onerror="this.src='assets/themes/icons/gr/connections.svg'">
                          <img *ngIf="expProd.value===exploreSection.INSIGHTS" class="explore-menu-icon" src={{expProd.icon_url}}  onerror="this.src='assets/themes/icons/gr/connections.svg'">
                          <img *ngIf="expProd.value===exploreSection.LINK" class="explore-menu-icon" src={{expProd.icon_url}}  onerror="this.src='assets/themes/icons/gr/connections.svg'">
                          <img *ngIf="expProd.value===exploreSection.OTSUKAFORM" class="explore-menu-icon" src={{expProd.icon_url}}  onerror="this.src='assets/themes/icons/gr/connections.svg'">
                          <img *ngIf="expProd.value===exploreSection.GR_FILTER" class="explore-menu-icon" src={{expProd.icon_url}}   onerror="this.src='assets/images/profile-explore/nejm.svg'">

                          <img *ngIf="expProd.value===exploreSection.CHATS " class="explore-menu-icon" src={{expProd.icon_url}}  onerror="this.src='assets/themes/icons/gr/chat.svg'">

                          <img *ngIf="expProd.value===exploreSection.CALENDER" class="explore-menu-icon" src={{expProd.icon_url}}   onerror="this.src='assets/images/profile-explore/calendar.svg'">
                          <img *ngIf="expProd.value===exploreSection.ONLINE_EVENT " class="explore-menu-icon" src={{expProd.icon_url}} onerror="this.src='assets/themes/icons/gr/online-event.svg'">

                          <img *ngIf="expProd.value===exploreSection.EDITORS_CHOICE" class="explore-menu-icon" src={{expProd.icon_url}} onerror="this.src='assets/themes/icons/gr/insight-collector.svg'">
                          <img *ngIf="expProd.value===exploreSection.COMMUNITY" class="explore-menu-icon" src={{expProd.icon_url}} onerror="this.src='assets/themes/icons/gr/community.svg'">
                          <img *ngIf="expProd.value===exploreSection.SHARE_POST && expProd.icon_url !=''" class="explore-menu-icon" src={{expProd.icon_url}} />

                          <img *ngIf="expProd.value===exploreSection.DX && expProd.icon_url !=''" src="https://media.docquity.com/doc-web-app/assets/images/web-dx-icon.svg" class="explore-menu-icon" (click)="navigateToDX()" />
                        </span><span class="color-grey-700">{{expProd.name}} <img width="12" height="12" src="assets/themes/icons/gr/right-arrow-grey.svg" alt="" class="right-nav-icon"></span>
                        <img class="newTagImg" [src]="expProd.value | newTagImage : this.dss.exploreNewTags" [ngStyle]="{'display':  expProd.value | newTags : this.dss.exploreNewTags}"  />
                      </a>
                    </div>
                    <div class="separator-line mx-3" *ngIf="expProd.value !== '' && expProd.value !== exploreSection.CHATS"></div>
                </li>
              </ng-container>
            </ul>
        </div>
      </div>
      <!-- end explore -->
  <!--referal part  -->
  </div>
</div>

  <!-- TODO: Nilesh : Commented code for refer n earn -->
  <!-- <div class="mt-1">
    <div *ngIf="loginUserCustomeId==profileInfo?.custom_id" class="refer_earn_div p-1 pl-3 pr-3 mb-0">
     <a href="javascript:(void)" (click)="navigateToReferal()" [eventTracker]='{"category":mls.googleEventText.grandround_left_section.category,
     "action":mls.googleEventText.grandround_left_section.key2,"product_type":"", "product_id":""}' class="rfer_aern fnt-size14px text-very-dark-grey" >
       <p><img src="assets/images/profile-explore/refer.svg" width="18px" class="mr-2"/>
        <span> {{mls?.languageText?.grandround_left_section?.key2}}
          <span *ngIf="mls?.is_lskey_display==1">(grandround_left_section.key2)</span>
        </span>
      </p>
    </a>
    </div>
  </div> -->
<!--
<div *ngIf="uploadProfile" [config]="{ show: true, backdrop: 'static' }" (onHidden)="onHidden()"  bsModal #autoShownModal="bs-modal" class="modal fade uploadProfileModal" tabindex="-1" role="dialog" aria-hidden="true" >
    <div class="modal-dialog modal-md">
        <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hideModal()"><span aria-hidden="true">&times;</span></button>
             <h4 class="modal-title">{{multiLangService.Edit_Photo}}</h4>
          </div>
          <div class="modal-body text-center">

        <div *ngIf="finished==true" class='text-center'>
            <img src="./assets/images/loader-small.svg" width="40" height="100" id="loadmore_post">
        </div>

           <div class="member-pic">


            <img [src]="edit_profile_pic_path | fitInImg :igs.imageGroup.fitin_320x320 | imagefilter:'./assets/images/default_pic.png'"   onError="this.src='assets/images/default_pic.png';" />
          <div class="camera-uploadBox">
          <a href="javascript:void(0);" class="fas fa-pencil-alt"></a>
        <input type="file" (change)="fileChangeEvent($event)" class="inputfile" accept="image/*">
        <input type="hidden" name="new_profile_pic" id="new_profile_pic" value="">
          </div>
        </div>
          </div>
     <div class="modal-footer">
     <div class="save-upload-photo">
     <a class="btn mini-btn btn-default" (click)="cancelFileChangeEvent()">{{multiLangService.cancel}}</a>
      <a class="btn mini-btn btn-secondry" (click)="updateProfilePic()">{{multiLangService.Save}}</a>
         </div>
       </div>
     </div>
   </div>
</div> -->
<!--   <a class="btn btn-primary" id="sidebarViewBtn" onClick="showAboutTab()" [href]="'#/web/profile/'+profileInfo?.custom_id+'/user'" -->

<!-- http://dev.docquity.com/web/#/profile?customeId=C8499da9af7688f4a709db6de669b55f8 -->
